import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";

import { connect } from "react-redux";
import { ProductSearch } from "../../../redux/actions/Product.Action";
import { LazyLoadImage } from "react-lazy-load-image-component";

class CategorySlider extends Component {
  render() {
    const CategoryList = this.props.Category || [];
    return (
      <div className="card">
        <div className="card-title p-2">
          <h6>Category</h6>
        </div>
        <div className="card-body p-0">
          <Swiper
            slidesPerView={4}
            spaceBetween={10}
            breakpoints={{
              640: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 7,
                spaceBetween: 0,
              },
            }}
            className="mySwiper pt-2"
          >
            {CategoryList.map((category, index) => (
              <SwiperSlide
                className="category_slider bg-white"
                key={index}
                onClick={() => this.props.ProductSearch(category.id)}
              >
                <div className="align-items-start text-center">
                  <LazyLoadImage
                    effect="blur"
                    className="avatar"
                    width={40}
                    height={40}
                    src={category.image}
                    alt={category.name}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <span className="subtitle">{category.name}</span>
                </div>
                <div className="d-flex align-items-end justify-content-center">
                  <span className="title">{category.total_product} items</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    Category: state.Products.Category,
  }),
  { ProductSearch }
)(React.memo(CategorySlider));
